import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { ChevronRight } from "lucide-react";

export type NavigationItem = { key: string; label: string; path: string; icon: LucideIcon; badge?: number };

export function AppFrame({ children, navigation, pathname, onNavigate, company, user, role, settingsNavigation }: {
  children: ReactNode; navigation: readonly NavigationItem[]; pathname: string; onNavigate: (path: string) => void;
  company: string; user: string; role: string; settingsNavigation?: readonly { path: string; label: string }[];
}) {
  const navigate = (event: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault(); onNavigate(path);
  };
  return <div className="v365-app-shell">
    <a className="v365-skip-link" href="#workspace">Skip to content</a>
    <aside className="v365-sidebar" aria-label="Workspace navigation">
      <a href="/today" className="v365-brand" onClick={(e) => navigate(e, "/today")}><img src="/icon.svg" alt="" width={36} height={36} /><span>venue<span>365</span></span></a>
      <div className="v365-company"><span>WORKSPACE</span><strong>{company}</strong></div>
      <nav aria-label="Main">
        {navigation.map(({ key, path, label, icon: Icon, badge }) => {
          const active = pathname === path || (path !== "/more" && pathname.startsWith(`${path}/`));
          return <a key={key} href={path} onClick={(e) => navigate(e, path)} aria-current={active ? "page" : undefined}><Icon size={20} aria-hidden /><span>{label}</span>{Boolean(badge) && <small>{badge}</small>}</a>;
        })}
      </nav>
      <a href="/more" className="v365-account" onClick={(e) => navigate(e, "/more")}><span className="v365-account-avatar">{user.slice(0, 1).toUpperCase()}</span><span><strong>{user}</strong><small>{role}</small></span><ChevronRight size={16} aria-hidden /></a>
    </aside>
    <div className="v365-app-body" id="workspace" tabIndex={-1}>{children}</div>
    {settingsNavigation && <nav className="v365-settings-nav" aria-label="Settings sections"><span>SETTINGS</span>{settingsNavigation.map(({ path, label }) => <a key={path} href={path} onClick={(e) => navigate(e, path)} aria-current={pathname === path ? "page" : undefined}>{label}</a>)}</nav>}
  </div>;
}
